/**
 * The Leads drawer's Un-suppress prompts (23 October 2026, review). Lifting a
 * suppression mails the person again. One that records an unsubscribe (the
 * email link, a lead marked unsubscribed, the backfill) needs a note of how
 * the person consented again: the Api refuses it without one (409
 * UNSUBSCRIBE_NEEDS_RECONSENT). Any other is confirmed with its reason shown.
 */

/** The prompt for the re-consent note. */
export function unsuppressReconsentPrompt(reason: string): string {
  return [
    `This address is suppressed because the person unsubscribed ("${reason}").`,
    'Lifting it mails them again. Do it only if they asked to be emailed again.',
    'How and when did they ask? (at least 10 characters; kept in the audit log)',
  ].join('\n');
}

/** The confirm for a suppression that is not an unsubscribe. */
export function unsuppressConfirmText(reason: string | null): string {
  return [
    `Un-suppress this address? Reason it was suppressed: ${reason || 'none recorded'}.`,
    'Send lists may email it again.',
  ].join('\n');
}
